import React from 'react';
import PropTypes from 'prop-types';

const ArrowRightCarouselIcon = ({ className = '', ...props }) => (
  <svg
    width="12"
    height="20"
    viewBox="0 0 12 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path d="M1 1L10 10L1 19" stroke="currentColor" strokeWidth="2" />
  </svg>
);

ArrowRightCarouselIcon.propTypes = {
  className: PropTypes.string,
};


export default ArrowRightCarouselIcon;
